import { useEffect } from 'react';
import useStore from './store';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorationTypes = () => {

    const storedTypeList = useStore((state) => state.decorationTypeList)
    const setStoredTypeList = useStore((state) => state.setDecorationTypeList)

    console.log(`DEC_TEST storedTypeList?.length: ${storedTypeList?.length}`)

    useEffect(() => { // Axios request use to be inside useEffect to get executed once.
        if (!storedTypeList?.length) {
            decorationRepository.getDecorationTypes()
                .then((data) => {
                    setStoredTypeList(data)
                })
                .catch((err) => {
                    console.error("Failed to fetch decoration types:", err)
                });
        }
    }, [storedTypeList, setStoredTypeList]);

    return storedTypeList;
};